import * as couponLikeTypes from "../types/couponLikeTypes";
import * as authTypes from "../types/authTypes";
import * as userTypes from "../types/userTypes";

const initialState = {
  likedCoupons: [],
  listLoading: false,
  listError: null,
  toggleLoading: false,
  toggleError: null,
  toggleCouponId: null,
};

function dedupePrepend(list, coupon) {
  if (!coupon?.id) return list;
  const rest = list.filter((c) => c.id !== coupon.id);
  return [coupon, ...rest];
}

export default function couponLikeReducer(state = initialState, action) {
  switch (action.type) {
    case couponLikeTypes.COUPON_LIKED_LIST_REQUEST:
      return { ...state, listLoading: true, listError: null };
    case couponLikeTypes.COUPON_LIKED_LIST_SUCCESS:
      return {
        ...state,
        listLoading: false,
        listError: null,
        likedCoupons: action.payload || [],
      };
    case couponLikeTypes.COUPON_LIKED_LIST_FAILURE:
      return { ...state, listLoading: false, listError: action.payload };

    case couponLikeTypes.COUPON_LIKE_ADD_REQUEST:
      return {
        ...state,
        toggleLoading: true,
        toggleError: null,
        toggleCouponId: action.payload?.couponPublicId || null,
      };
    case couponLikeTypes.COUPON_LIKE_ADD_SUCCESS: {
      const coupon = action.payload?.data?.coupon;
      return {
        ...state,
        toggleLoading: false,
        toggleError: null,
        toggleCouponId: null,
        likedCoupons: coupon
          ? dedupePrepend(state.likedCoupons, coupon)
          : state.likedCoupons,
      };
    }
    case couponLikeTypes.COUPON_LIKE_ADD_FAILURE:
      return {
        ...state,
        toggleLoading: false,
        toggleError: action.payload,
        toggleCouponId: null,
      };

    case couponLikeTypes.COUPON_LIKE_REMOVE_REQUEST:
      return {
        ...state,
        toggleLoading: true,
        toggleError: null,
        toggleCouponId: action.payload?.couponPublicId || null,
      };
    case couponLikeTypes.COUPON_LIKE_REMOVE_SUCCESS:
      return {
        ...state,
        toggleLoading: false,
        toggleError: null,
        toggleCouponId: null,
        likedCoupons: state.likedCoupons.filter(
          (c) => c.id !== action.payload?.couponPublicId
        ),
      };
    case couponLikeTypes.COUPON_LIKE_REMOVE_FAILURE:
      return {
        ...state,
        toggleLoading: false,
        toggleError: action.payload,
        toggleCouponId: null,
      };

    case couponLikeTypes.COUPON_LIKE_CLEAR:
    case userTypes.USER_CLEAR:
    case authTypes.LOGOUT:
      return { ...initialState };

    default:
      return state;
  }
}
